





import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Prop, Watch } from "vue-property-decorator";
@Component({
})
export default class InputFieldComponent extends Vue {
    @Prop() lable;
    @Prop() model;
    data :any={}
}
